import EcoLink from 'eco-design/base/eco-link';
import { useRouter } from 'next/router';
import IconLogo from '../../Header/icons/IconLogo';
export default function HeaderLogo() {
    const { locale = 'us' } = useRouter();
    return (
        <EcoLink
            href={`/${locale}`}
            className="logoLink GtmModuleData-btn-common"
            data-btn-id="logo"
            dataLayer={{
                event: 'uaEvent',
                event_name: 'top_function',
                button_name: 'Logo',
                __btn_id1: `ef-header-logo`,
                __btn_id2: `logo`,
                __btn_type: 'common',
            }}
        >
            <IconLogo />
            <p style={{ opacity: '0', width: '0', height: '0', pointerEvents: 'none' }}>{'EcoFlow'}</p>
        </EcoLink>
    );
}
